/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019-2023 (original work) Open Assessment Technologies SA
 *
 */

import pageController from './page.js';
import TheEnd from '../component/TheEnd.svelte';
import { __ } from '@oat-sa-private/ui-core';

export default () =>
    pageController({
        name: 'thankyou',

        start({ lti_msg }) {
            this.theEndComponent = new TheEnd({
                target: this.container,
                props: {
                    title: __('Thank you'),
                    info: lti_msg || __('Your test has been submitted.'),
                    icon: 'finish-16'
                }
            });
        },

        stop() {
            if (this.theEndComponent) {
                this.theEndComponent.$destroy();
            }
        }
    });
